import { LuListFilter, LuFileSpreadsheet } from "react-icons/lu";

const SCOPE_BY_CATEGORY = {
    users: [
        { id: "all", label: "Të gjitha" },
        { id: "current_month", label: "Muaji aktual" },
    ],
    receipts: [
        { id: "all", label: "Të gjitha" },
        { id: "current_month", label: "Muaji aktual" },
    ],
    winners: [
        { id: "all", label: "Të gjitha" },
        { id: "previous_month", label: "Loja e fundit" },
    ],
    business_winners: [
        { id: "all", label: "Të gjitha" },
        { id: "previous_month", label: "Loja e fundit" },
    ],
};

export default function ReportsToolbar({
    category,
    scope,
    onScopeChange,
    onOpenFilters,
    activeFilterCount,
    onExport,
}) {
    const scopes = SCOPE_BY_CATEGORY[category] || [];

    return (
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3">
            <div className="inline-flex items-center gap-1.5 rounded-xl border border-gray-200 bg-white p-1 shadow-sm w-max">
                {scopes.map((s) => {
                    const isActive = s.id === scope;
                    return (
                        <button
                            key={s.id}
                            type="button"
                            onClick={() => onScopeChange(s.id)}
                            className={`px-3.5 h-9 rounded-lg text-sm font-semibold transition ${
                                isActive
                                    ? "bg-secondary text-white shadow-sm"
                                    : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                            }`}
                        >
                            {s.label}
                        </button>
                    );
                })}
            </div>

            <div className="inline-flex items-center gap-2">
                <button
                    type="button"
                    onClick={onOpenFilters}
                    className={`relative inline-flex items-center gap-2 h-10 px-4 rounded-xl border bg-white text-sm font-semibold shadow-sm transition ${
                        activeFilterCount > 0
                            ? "border-secondary text-secondary"
                            : "border-gray-200 text-gray-700 hover:bg-gray-50"
                    }`}
                >
                    <LuListFilter size={18} />
                    Filterat
                    {activeFilterCount > 0 && (
                        <span className="ml-1 inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-secondary text-white text-[11px] font-bold">
                            {activeFilterCount}
                        </span>
                    )}
                </button>
                <button
                    type="button"
                    onClick={onExport}
                    className="inline-flex items-center gap-2 h-10 px-4 rounded-xl bg-secondary hover:bg-secondary/90 active:scale-[0.98] text-sm font-semibold text-white shadow-sm transition"
                >
                    <LuFileSpreadsheet size={16} />
                    Eksporto Excel
                </button>
            </div>
        </div>
    );
}
